/** @format */
import React, { useContext } from 'react';

import { ProductConditionValue } from '@toucan/types/product';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';
import { ProductConditionDescriptionModal } from '@toucan/features/product/components/molecules/product-condition-description-modal';

export function useProductConditionDescriptionModal() {
    const { setModalVisible, setModalContent } = useContext(ApplicationContext);

    const showProductConditionDescriptionModal = (
        condition: ProductConditionValue,
        conditionDescription: string
    ) => {
        setModalContent(
            <ProductConditionDescriptionModal
                condition={condition}
                conditionDescription={conditionDescription}
                onClose={() => setModalVisible(false)}
            />
        );
        setModalVisible(true, {
            size: ModalSize.MEDIUM,
        });
    };

    return {
        showProductConditionDescriptionModal,
    };
}
